import './code.component.scss';

import { Component } from 'preact';

import { SpinnerComponent } from '../../common/components/spinner/spinner.component';
import { t } from '../../i18n';
import type { Code } from '../../models/code.interface';
import { CodeState } from '../../models/code.interface';
import { QRComponent } from './qr.component';

interface CodeComponentProps {
  code: Code;
}

export class CodeComponent extends Component<CodeComponentProps> {
  render() {
    const { code } = this.props;

    if (code.state === CodeState.PROCESSING) {
      return (
        <div className="single-code">
          <div className="single-code-processing">
            <div className="single-code-processing-overlay">
              <SpinnerComponent></SpinnerComponent>
              <span>{t('perks.generating')}</span>
            </div>
            <QRComponent text="Generating QR Code" />
          </div>
          <div className="single-code-name">{code.campaignName}</div>
          <div>{code.campaignDescription}</div>
        </div>
      );
    }

    return (
      <div className="single-code">
        <QRComponent text={code.code} />
        <div className="single-code-name">{code.campaignName}</div>
        <div>{code.campaignDescription}</div>
      </div>
    );
  }
}
